import { ShippingWay } from "@/services/api/orderShip";

const ShippingWayNameMap = {
    [ShippingWay.OFFLINE]: "自己联系物流",
    [ShippingWay.ONLINE]: "在线下单",
    [ShippingWay.VIRTUAL]: "无需物流",
};

export default ShippingWayNameMap;
